import React, { useState, useEffect } from 'react';
import { Card, CardBody, Col, Container, Row, Table, CardHeader, Button } from 'reactstrap';
import { Link, useParams } from 'react-router-dom';
import MetaTags from "react-meta-tags";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from '../BaseUrl/ApiClient';
import './LSDealDetail.css';

function LSDealDetail() {
    const { dealId } = useParams();
    const [deal, setDeal] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const fetchDealDetails = async () => {
        setLoading(true);
        setError(null);
        try {
            const client = ApiClient();
            const response = await client.get(`business/deal/lunchSpecials/${dealId}`);
            const fetchedDeal = response.data.responseData.deal;
            setDeal(fetchedDeal);
        } catch (err) {
            setError('Failed to fetch deal details. Please try again.');
            toast.error('Failed to fetch deal details.');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (dealId) {
            fetchDealDetails();
        }
    }, [dealId]);

    if (loading) {
        return (
            <div className="page-content">
                <Container fluid className="mt-5">
                    <div className="text-center">
                        <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="secondary:#121331,secondary:#08a88a"
                            style={{ width: '75px', height: '75px' }}
                        ></lord-icon>
                        <h5 className="mt-2">Loading Deal Details...</h5>
                    </div>
                </Container>
            </div>
        );
    }

    if (error || !deal) {
        return (
            <div className="page-content">
                <Container fluid className="mt-5">
                    <div className="text-center">
                        <lord-icon
                            src="https://cdn.lordicon.com/msoeawqm.json"
                            trigger="loop"
                            colors="secondary:#121331,secondary:#08a88a"
                            style={{ width: '75px', height: '75px' }}
                        ></lord-icon>
                        <h5 className="mt-2">Sorry! No Deal Found</h5>
                        <p className="text-muted mb-0">{error || 'No deal data available.'}</p>
                    </div>
                </Container>
            </div>
        );
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="mt-5">
                    <MetaTags>
                        <title>Deal Details</title>
                    </MetaTags>
                    <ToastContainer />

        
                    <div className="mb-3 ms-4">
                        <Link to="/lunch-deal-list">
                            <Button color="primary" className="btn">
                                <i className="mdi mdi-arrow-left"></i>
                            </Button>
                        </Link>
                    </div>

                    <div className="deal-container">
                        <Row>
                            <Col lg="4" md="6">  
                                <div className="deal-image-container">
                                    {deal.dealPhoto?.url ? (
                                        <img
                                            src={deal.dealPhoto.url}
                                            alt={deal.name}
                                            className="deal-image"
                                        />
                                    ) : (
                                        <span>No image available</span>
                                    )}
                                </div>
                            </Col>
                            <Col lg="8" md="6">   
                                <div className="deal-details">
                                    <div className='d-flex deal-category align-items-center '>
                                        <h1 className='dealname me-3'>{deal.name}</h1>
                                        <div className={`deal-status ${deal.isActive ? 'active' : 'inactive'}`}>
                                            {deal.isActive ? 'Available' : 'Currently Unavailable'}
                                        </div>
                                    </div>
                                    <div  className="deal-category d-flex align-items-center">
                                        <p className='dealsubhead'> Price: <span className='catName'>$ {deal.price || 'N/A'}</span> </p>
                                    </div>
                                     
                                    <div  className="deal-category d-flex align-items-center">
                                        <p className='dealsubhead'>Categories:</p>
                                        {deal.category?.categoryLogo?.url ? (
                                            <img
                                                src={deal.category.categoryLogo.url}
                                                alt={deal.category.name}
                                                className="category-logo"
                                            />
                                        ) : (
                                            <></>
                                        )}
                                        <span className='catName'>{deal.category?.name || 'N/A'}</span>
                                    </div>
                                         <div  className="deal-category d-flex align-items-center">
                                        <p className='dealsubhead'>Available Days:</p>
                                        <div className="days-pills">
                                            {deal.days && deal.days.length > 0 ? (
                                                deal.days.map((day, index) => (
                                                    <span key={index} className="day-pill">{day}</span>
                                                ))
                                            ) : (
                                                <span>No days specified</span>
                                            )}
                                        </div>
                                    </div>
                                  {/* <div>
                                        <p className='dealsubhead'>Available Day:</p>
                                        <div className="days-pills">
                                            {deal.day ?(
                                                
                                                    <span className="day-pill">{deal.day}</span>
                                                
                                            ) : (
                                                <span>No days specified</span>
                                            )}
                                        </div>
                                    </div> */}
                                      {/* {deal.time && (
                                            <div>
                                                <h5 className="text-muted">Time: <span className="text-dark">{deal.time}</span></h5>
                                            </div>
                                        )} */}
                                </div>  
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    );
}

export default LSDealDetail;